export const enum RuleTypeEnum {
  RuleCombo = 'RuleCombo',
  CustomEventRule = 'CustomEventRule',
  SystemEventRule = 'SystemEventRule',
  UserPropertyRule = 'UserPropertyRule',
  ConversionMetExitRule = 'ConversionMetExitRule',
}
